import {ActivityHotelState} from "../../types-enums/activity-hotel";
import {DurationProps} from "../../types-enums/activity-common-properties";
import {hasExactDates} from "../getter/journey";
import {isHotelCalculationRequest} from "../check/type-guards";

/**
 * Updates the duration of a hotel stay when adding it to a journey. If the journey has exact dates,
 * the hotel stay is set with specific start and end dates. If the journey does not have exact dates,
 * the duration of the hotel stay is set to 1 day/night.
 *
 * @param {ActivityHotelState} hotel - The current state of the hotel activity, including properties
 * such as the common details and hotel stay duration.
 * @param {DurationProps} journeyDuration - The duration details of the journey, which may include
 * exact dates or general day/night information.
 */
export const setDurationOfHotelToOneWhenAddingToJourney = (hotel: ActivityHotelState, journeyDuration: DurationProps) => {
    const journeyWithExactDates = hasExactDates(journeyDuration)
    if (journeyWithExactDates) {
        const {common: {day}} = hotel
        const {dates} = journeyDuration
        if (dates && day !== null) {
            const {startDate} = dates
            hotel.hotelStayDuration.dates = {
                startDate: startDate.plus({days: day - 1}),
                endDate: startDate.plus({days: day}),
            }
            hotel.hotelStayDuration.daysOrNights = null
        }
    } else {
        hotel.hotelStayDuration.dates = null
        hotel.hotelStayDuration.daysOrNights = 1
    }

    if (hotel.common.request && isHotelCalculationRequest(hotel.common.request[0])) hotel.common.request[0].numberOfNights = 1
}